import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import { SkeletonPage } from "./components/SkeletonLoader";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load pages for better performance
const HomePage = lazy(() => import("./pages/home"));
const AboutUs = lazy(() => import("./pages/about"));
const Pillars = lazy(() => import("./pages/pillars"));
const Products = lazy(() => import("./pages/products"));
const Solutions = lazy(() => import("./pages/solutions"));
const Research = lazy(() => import("./pages/research"));
const Partners = lazy(() => import("./pages/partners"));
const Contact = lazy(() => import("./pages/contact"));
const Services = lazy(() => import("./pages/services"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SEO
        title="IQ Leap - Quantum Intelligence for Smarter Decisions"
        description="IQ Leap develops next-generation quantum and AI-powered software for decision optimization, automation, and advanced analytics—empowering industries with standalone quantum solutions."
        keywords="quantum computing, AI software, quantum optimization, quantum algorithms, drug discovery, portfolio optimization, quantum key distribution, QKD"
      />
      <Header />
      <Suspense fallback={<SkeletonPage />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aboutus" element={
            <>
              <SEO
                title="About Us - IQ Leap"
                description="IQ Leap is a deep-tech organization focused on quantum software innovation, AI integration, and research-driven solutions."
              />
              <AboutUs />
            </>
          } />
          <Route path="/pillars" element={
            <>
              <SEO
                title="Our Core Pillars - IQ Leap"
                description="Products, Solutions, and Research - The three foundational pillars driving quantum intelligence innovation."
              />
              <Pillars />
            </>
          } />
          <Route path="/products" element={
            <>
              <SEO
                title="Products - IQ Leap"
                description="Explore our quantum-enhanced software solutions: Portfolio Optimizer, Warehouse Allocation, Drug Docking, Risk Management, and QKD for Satellites."
              />
              <Products />
            </>
          } />
          <Route path="/solutions" element={
            <>
              <SEO
                title="Industry Solutions - IQ Leap"
                description="Quantum intelligence solutions for Logistics, Drug Discovery, Finance, Secure Communications, and Data Processing."
              />
              <Solutions />
            </>
          } />
          <Route path="/research" element={
            <>
              <SEO
                title="Publications & Research - IQ Leap"
                description="Research papers on Quantum Generative Transformers, Thermally Resilient Quantum Memory, Graph Algorithms, and Quantum Communication."
              />
              <Research />
            </>
          } />
          <Route path="/partners" element={
            <>
              <SEO
                title="Partners & Collaborators - IQ Leap"
                description="Collaborating with IBM, Amazon Braket, NIT Puducherry, RGUKT, and DataTeach for quantum innovation."
              />
              <Partners />
            </>
          } />
          <Route path="/contact" element={
            <>
              <SEO
                title="Contact Us - IQ Leap"
                description="Get in touch with IQ Leap. Head Office: Hyderabad, India. Email: info@theiqleap.com"
              />
              <Contact />
            </>
          } />
          <Route path="/services" element={
            <>
              <SEO 
                title="Services - IQ Leap Research"
                description="Quantum Product Development, Research Collaboration, Education Programs, Consulting, and Data Process Optimization services."
              />
              <Services />
            </>
          } />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
